"use client";

import {
  type AddressInput,
  execute,
  GET_USER_GEOLOCATION,
  QUERY_KEYS,
  saveUserLocation,
} from "@frontend/roz-sdk-core";
import { toast } from "@frontend/roz-uikit";
import { Button } from "@frontend/roz-uikit/studio";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { AddressSelect } from "@/lib/AddressSelect";
import { calcGeoPlaceInfo } from "@/lib/region-helpers";
import { useSheetStore } from "@/ui-state";

export const RegionSelect = () => {
  const [place, setPlace] = useState<AddressInput | null>(null);
  const { close } = useSheetStore();
  const { data } = useQuery({
    queryFn: () => execute(GET_USER_GEOLOCATION),
    queryKey: QUERY_KEYS.userGeolocation,
  });
  const geolocation = data?.userGeoLocationLog;

  const locationParts = [geolocation?.country, geolocation?.region].filter(
    Boolean
  );
  const isEmpty = locationParts.length === 0;

  const { placeWord, showingPlace } = calcGeoPlaceInfo(geolocation);

  const handleSave = () => {
    if (!place) {
      toast.info(`Пожалуйста, заполните ваш ${placeWord}`);
      return;
    }
    saveUserLocation({
      region: place.region,
      city: place.city,
      regionFiasId: place.regionFiasId,
      country: place.country,
      cityFiasId: place.cityFiasId,
      countryIsoCode: place.countryIsoCode,
    });
    close();
  };

  return (
    <div className="sdkui:flex sdkui:flex-1 sdkui:flex-col sdkui:items-start sdkui:justify-between sdkui:max-sm:mt-13 sdkui:max-sm:flex-col sdkui:sm:max-w-[85vw] sdkui:sm:justify-center sdkui:sm:p-4 sdkui:md:max-w-140 sdkui:max-lg:landscape:block sdkui:max-lg:landscape:overflow-y-auto">
      <div>
        <h2 className="sdkui:mb-10 sdkui:font-aqum2 sdkui:font-black sdkui:text-2xl sdkui:text-dark-100 sdkui:uppercase sdkui:leading-none sdkui:max-sm:pr-7 sdkui:md:text-4xl">
          Укажите ваш {placeWord}
        </h2>
        {isEmpty ? (
          <p className="sdkui:mb-10 sdkui:max-w-144 sdkui:text-dark-100 sdkui:text-xl sdkui:leading-8">
            Не удалось определить ваш {placeWord}, пожалуйста, укажите его
            вручную
          </p>
        ) : (
          <>
            <p className="sdkui:text-dark-100 sdkui:text-xl sdkui:leading-8">
              Мы определили ваш {placeWord} как:
            </p>
            <p className="sdkui:mt-4 sdkui:mb-5 sdkui:font-bold sdkui:text-dark-100 sdkui:text-xl sdkui:uppercase sdkui:leading-8 sdkui:sm:mb-8">
              {showingPlace}.
            </p>
          </>
        )}
        {!isEmpty && (
          <p className="sdkui:mb-13.5 sdkui:max-w-156 sdkui:text-dark-100 sdkui:text-md sdkui:leading-8">
            Если это не верно, пожалуйста, выберите тот {placeWord}, в котором
            вы сейчас находитесь. Это позволит отображать наиболее актуальную
            для вас информацию.
          </p>
        )}

        <p className="sdkui:mb-2 sdkui:text-dark-90 sdkui:text-sm sdkui:leading-5 sdkui:max-sm:text-xs">
          Укажите ваш {placeWord}
        </p>
        <AddressSelect
          inputPlaceholder={`Введите ${placeWord}`}
          onChange={setPlace}
          startTypingPlaceholder={`Начните вводить ${placeWord}`}
          value={place}
        />
      </div>
      <Button
        className="sdkui:mt-11 sdkui:uppercase sdkui:max-sm:w-full sdkui:max-s:mb-7"
        onClick={handleSave}
        size="lg"
        variant="solidPrimary"
      >
        подтвердить
      </Button>
    </div>
  );
};
